/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOfferPaymentMethods404Response { 
    error_key?: GetOfferPaymentMethods404Response.ErrorKeyEnum;
}
export namespace GetOfferPaymentMethods404Response {
    export type ErrorKeyEnum = 'offer.not_found' | 'promocode.not_found';
    export const ErrorKeyEnum = {
        OfferNotFound: 'offer.not_found' as ErrorKeyEnum,
        PromocodeNotFound: 'promocode.not_found' as ErrorKeyEnum
    };
}


